import { createFileRoute } from '@tanstack/react-router';
import { uuidOrUndefined } from '../../../foundry/href.js';
import { ImportDetailPage } from '../../../foundry/ImportDetailPage.js';

export interface ImportDetailSearch {
  /** The sheet the review is against; by default the silent match. */
  targetSheetId?: string | undefined;
}

/** `/foundry/imports/$importId`: one import; `validateSearch` keeps `targetSheetId` (a uuid). */
export const Route = createFileRoute('/foundry/imports/$importId')({
  validateSearch: (search: Record<string, unknown>): ImportDetailSearch => ({
    targetSheetId: uuidOrUndefined(search.targetSheetId),
  }),
  component: ImportDetailRoute,
});

function ImportDetailRoute(): React.JSX.Element {
  const { me } = Route.useRouteContext();
  const { importId } = Route.useParams();
  const { targetSheetId } = Route.useSearch();
  return <ImportDetailPage me={me} importId={importId} targetSheetId={targetSheetId} />;
}
